import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';

var useFormControlValidation = function useFormControlValidation(props) {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    error = _React$useState2[0],
    setError = _React$useState2[1];
  var onValidatePerMinNumberRule = React.useCallback(function (errorType, val, validationRule) {
    val = parseFloat(val);
    if (!val) return null;
    if (typeof validationRule === "number" && val < validationRule) {
      var _props$ref;
      return {
        ref: (_props$ref = props.ref) === null || _props$ref === void 0 ? void 0 : _props$ref.current,
        type: errorType
      };
    }
    validationRule = validationRule;
    if (val < validationRule.value) {
      var _props$ref2;
      return {
        message: validationRule.message,
        ref: (_props$ref2 = props.ref) === null || _props$ref2 === void 0 ? void 0 : _props$ref2.current,
        type: errorType
      };
    }
    return null;
  }, [props.ref]);
  var onValidatePerMaxNumberRule = React.useCallback(function (errorType, val, validationRule) {
    val = parseFloat(val);
    if (!val) return null;
    if (typeof validationRule === "number" && val > validationRule) {
      var _props$ref3;
      return {
        ref: (_props$ref3 = props.ref) === null || _props$ref3 === void 0 ? void 0 : _props$ref3.current,
        type: errorType
      };
    }
    validationRule = validationRule;
    if (val > validationRule.value) {
      var _props$ref4;
      return {
        message: validationRule.message,
        ref: (_props$ref4 = props.ref) === null || _props$ref4 === void 0 ? void 0 : _props$ref4.current,
        type: errorType
      };
    }
    return null;
  }, [props.ref]);
  var onValidate = React.useCallback(function (val, allValues) {
    if (!props.validation) {
      return null;
    }
    var err = null;
    if (props.validation.required && (val === void 0 || val === null || val === "")) {
      var _props$ref5;
      var errorMessage = typeof props.validation.required === "string" ? props.validation.required : void 0;
      err = {
        message: errorMessage,
        type: "required",
        ref: (_props$ref5 = props.ref) === null || _props$ref5 === void 0 ? void 0 : _props$ref5.current
      };
    } else if (props.validation.min !== void 0) {
      err = onValidatePerMinNumberRule("min", val, props.validation.min);
    } else if (props.validation.max !== void 0) {
      err = onValidatePerMaxNumberRule("max", val, props.validation.max);
    } else if (props.validation.minLength !== void 0) {
      err = onValidatePerMinNumberRule("minLength", val === null || val === void 0 ? void 0 : val.length(), props.validation.minLength);
    } else if (props.validation.maxLength !== void 0) {
      err = onValidatePerMaxNumberRule("maxLength", val === null || val === void 0 ? void 0 : val.length(), props.validation.maxLength);
    } else if (props.validation.validate) {
      var validationResult = props.validation.validate(val, allValues);
      if (validationResult) {
        var _props$ref6;
        err = {
          message: validationResult,
          type: "validate",
          ref: (_props$ref6 = props.ref) === null || _props$ref6 === void 0 ? void 0 : _props$ref6.current
        };
      }
    }
    setError(err);
    return err;
  }, [props.ref, props.value, props.validation]);
  return {
    error: error,
    onValidate: onValidate
  };
};

export { useFormControlValidation };
